<template>
  <div style="overflow: auto;">
    <el-table
      ref="multipleTable"
      :data="list"
      size="mini"
      border
      style="width:100%;"
      height="300px"
      tooltip-eff0-ect="dark"
      highlight-current-row
      @current-change="handleCurrentChange"
    >
      <el-table-column prop="姓名" label="姓名" width="60">
        <template slot-scope="scope">
          <a class="company-pointer ft14" @click="showRadishDetail(scope.row.rid)">{{
            scope.row.radish && scope.row.radish.姓名
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="性别" label="性别" width="80">
        <template slot-scope="scope">
          <span class="ft14">{{ scope.row.radish && scope.row.radish.性别 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="目前公司" label="目前公司" width="80">
        <template slot-scope="scope">
          <span class="ft14">{{ scope.row.radish && scope.row.radish.公司 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="目前职位" label="目前职位" width="120">
        <template slot-scope="scope">
          <span class="ft14">{{ scope.row.radish && scope.row.radish.目前职位 }}</span>
        </template>
      </el-table-column>

      <el-table-column label="人选进展阶段（反馈历史）" width="150">
        <template slot-scope="scope">
          <el-badge is-dot :hidden="!badge[`${scope.row.pid}${scope.row.rid}`]" class="radish-progress-dot">
            <div
              class="radish-btn radish-btn-primary"
              style="padding: 0px 20px;"
              @click="showRadishProgress(scope.row)"
            >
              {{ getTag(scope.row) }}
            </div>
          </el-badge>
        </template>
      </el-table-column>
      <el-table-column v-if="step !== '寻访沟通'" label="邮件">
        <template slot-scope="scope">
          <span
            v-if="scope.row.已绑定推荐报告 && scope.row.已绑定推荐报告.length && scope.row.已绑定推荐报告.length > 0"
            style="color:#67C23A"
          >
            有附件
          </span>
          <el-tooltip effect="dark" content="您是否没有发邮件给客户公司，请补充" placement="top-start">
            <span
              v-if="
                !scope.row.已绑定推荐报告 || !scope.row.已绑定推荐报告.length || scope.row.已绑定推荐报告.length === 0
              "
              style="color:#F56C6C"
            >
              无附件</span
            >
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column v-if="step === '开票催款'" label="到岗日期" width="100">
        <template slot-scope="scope">
          <span class="ft14">{{ (scope.row.towork && scope.row.towork.到岗日期) || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column v-else label="更新时间" width="100">
        <template slot-scope="scope">
          <span class="ft14">{{ dateFormat(scope.row.updatedAt, 'yyyy-mm-dd') }}</span>
        </template>
      </el-table-column>

      <el-table-column label="重启人选" width="115">
        <template slot-scope="scope">
          <div
            v-if="scope.row.状态 && (scope.row.状态.detail == '淘汰' || scope.row.状态.detail == '放弃')"
            class="radish-btn radish-btn-primary"
            style="padding: 0px 20px;"
            @click="reStart(scope.row)"
          >
            重启人选
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="step === '开票催款'" label="付款通知书" width="265">
        <template slot-scope="scope">
          <div
            v-if="
              getTag(scope.row) === '到岗' &&
                (!scope.row.状态.detail || scope.row.状态.detail == '未开票' || scope.row.状态.detail == '开票中')
            "
            class="radish-btn radish-btn-primary"
            style="padding: 0px 20px;"
            @click="makePayDoc(scope.row)"
          >
            {{ !scope.row.状态.detail ? '制作付款通知书' : '重新制作付款通知书' }}
          </div>
          <div
            v-if="getTag(scope.row) === '到岗' && scope.row.状态.detail == '未开票'"
            class="radish-btn radish-btn-primary"
            style="padding: 0px 20px;"
            @click="kaipiao(scope.row)"
          >
            开票
          </div>
          <div
            v-if="
              getTag(scope.row) === '过保' &&
                (scope.row.状态.detail == '需开票' ||
                  scope.row.状态.detail == '未开票' ||
                  scope.row.状态.detail == '开票中')
            "
            class="radish-btn radish-btn-primary"
            style="padding: 0px 20px;"
            @click="makePayDoc2(scope.row)"
          >
            {{ scope.row.状态.detail == '需开票' ? '制作二期付款通知书' : '重新制作二期付款通知书' }}
          </div>
          <div
            v-if="getTag(scope.row) === '过保' && scope.row.状态.detail == '未开票'"
            class="radish-btn radish-btn-primary"
            style="padding: 0px 20px;"
            @click="kaipiao(scope.row)"
          >
            开票
          </div>
        </template>
      </el-table-column>

      <!-- offer谈判 -->
      <el-table-column v-if="step === 'offer谈判'" label="offer" width="115">
        <template slot-scope="scope">
          <div
            v-if="getTag(scope.row) === '面试（终面）'"
            class="radish-btn radish-btn-primary"
            style="padding: 0px 20px;"
            @click="addOffer(scope.row)"
          >
            发起offer
          </div>
          <div
            v-else-if="getTag(scope.row) === 'offer谈判'"
            class="radish-btn radish-btn-primary"
            style="padding: 0px 20px;"
            @click="modifyOffer(scope.row)"
          >
            修改offer
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="step === 'offer谈判'" label="offer反馈 " width="120">
        <template slot-scope="scope">
          <div
            class="radish-btn radish-btn-primary"
            style="padding: 0px 20px;margin-left:5px;"
            @click="addOfferFeedback(scope.row)"
          >
            填写反馈
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column v-if="step === 'offer谈判'" label="人选进展/反馈历史" width="165">
        <template slot-scope="scope">
          <div class="radish-btn radish-btn-primary" style="padding: 0px 20px;" @click="showRadishProgress(scope.row)">
            人选进展/反馈历史
          </div>
        </template>
      </el-table-column> -->
      <el-table-column v-if="step === 'offer谈判'" label="offer确认" width="115">
        <template slot-scope="scope">
          <div class="radish-btn radish-btn-primary" style="padding: 0px 20px;" @click="showYejifenchengDia(scope.row)">
            确认offer
          </div>
          <!-- <div class="radish-btn radish-btn-primary" style="padding: 0px 20px;" @click="confirmOffer(scope.row)">
            确认offer
          </div> -->
        </template>
      </el-table-column>

      <!-- 离职管理 -->
      <el-table-column v-if="step === '离职管理'" label="离职辅导" width="115">
        <template slot-scope="scope">
          <div class="radish-btn radish-btn-primary" style="padding: 0px 20px;" @click="toLeaveGuide(scope.row)">
            离职辅导
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="step === '离职管理'" label="offer详情查看 " width="120">
        <template slot-scope="scope">
          <div class="radish-btn radish-btn-primary" style="padding: 0px 20px;" @click="modifyOffer(scope.row)">
            offer详情
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column v-if="step === '离职管理'" label="人选进展/反馈历史" width="165">
        <template slot-scope="scope">
          <div class="radish-btn radish-btn-primary" style="padding: 0px 20px;" @click="showRadishProgress(scope.row)">
            人选进展/反馈历史
          </div>
        </template>
      </el-table-column> -->
      <el-table-column v-if="step === '离职管理'" label="进展结果" width="200">
        <template slot-scope="scope">
          <div
            class="radish-btn radish-btn-primary mr5"
            style="padding: 0px 20px;"
            @click="openToworkConfirm(scope.row)"
          >
            确认到岗
          </div>
          <div class="radish-btn radish-btn-primary" style="padding: 0px 20px;" @click="openToworkNot(scope.row)">
            未入职
          </div>
        </template>
      </el-table-column>

      <!-- 离职管理 -->
      <el-table-column v-if="step === '开票催款'" label="offer详情" width="120">
        <template slot-scope="scope">
          <div class="radish-btn radish-btn-primary" style="padding: 0px 20px;" @click="modifyOffer(scope.row)">
            offer详情
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="step === '开票催款'" label="进展结果" width="200">
        <template v-if="getTag(scope.row) === '到岗'" slot-scope="scope">
          <div
            class="radish-btn radish-btn-primary mr5"
            style="padding: 0px 20px;"
            @click="openWarrantyConfirm(scope.row)"
          >
            确认过保
          </div>
          <div class="radish-btn radish-btn-primary" style="padding: 0px 20px;" @click="openWarrantyNot(scope.row)">
            未过保
          </div>
        </template>
      </el-table-column>

      <el-table-column v-if="step === '开票催款'" label="此单保证期 " width="100">
        <template slot-scope="scope">
          <span class="ft14">{{ scope.row.towork && scope.row.towork.试用期 }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="step === '开票催款'" label="过保日期 " width="100">
        <template slot-scope="scope">
          <span class="ft14">{{ getPassTowork(scope.row) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column v-if="step === '开票催款'" label="人选进展/反馈历史" width="165">
        <template slot-scope="scope">
          <div class="radish-btn radish-btn-primary" style="padding: 0px 20px;" @click="showRadishProgress(scope.row)">
            人选进展/反馈历史
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- components -->
    <ProgressDia ref="ProgressDia" :on-confirm="loadData"></ProgressDia>
    <radishProgress ref="radishProgress"></radishProgress>
    <YejifenchengDia ref="YejifenchengDia" @onConfirm="yejiConfirm"></YejifenchengDia>
  </div>
</template>
<script>
import ProgressDia from '../../../../radish/src/progress/progress-dia.vue'
import radishProgress from '../../../../radish/src/progress/radish-progress.vue'
import YejifenchengDia from '../../../../radish/src/progress/yejifencheng-dialog.vue'

const dateFormat = require('dateformat')

export default {
  components: {
    ProgressDia,
    radishProgress,
    YejifenchengDia
  },
  props: {
    project: { type: Object, default: () => ({}) },
    step: { type: String, default: '' },
  },
  data() {
    return {
      list: [],
      stepMap: {
        职位推荐: '已推荐',
        面试阶段: '面试',
        offer谈判: 'offer',
        离职管理: '到岗',
        开票催款: '到岗',
      },
      badge: {},
      curRow: {}
    }
  },
  watch: {
    project: {
      handler(newValue, oldValue) {
        this.getList()
      },
      immediate: true,
    },
    step: {
      handler(newValue, oldValue) {
        this.getList()
      },
      immediate: true,
    },
  },
  methods: {
    isShowBadge(row) {
      const { step, radishLogsStorage } = this
      const logs = row.logData || []
      const time = radishLogsStorage[`${row.pid}${row.rid}`] || 0
      const role = ['offer反馈', '确认offer', '离职辅导', '未入职', '到岗', '过保', '未过保']
      // if (step === 'offer谈判') {
      //   role = ['offer反馈', '确认offer']
      // } else if (step === '离职管理') {
      //   role = ['离职辅导', '未入职', '到岗']
      // } else if (step === '开票催款') {
      //   role = ['过保', '未过保']
      // }
      const arr = logs.filter(val => new Date(val.timestamp).getTime() > time && role.includes(val.type))
      return arr.length > 0
    },
    async checkLogs() {
      for (const row of this.list) {
        const logData = await this.getLogs(row)
        this.$set(row, 'logData', logData)
        const isShow = this.isShowBadge(row)
        this.$set(this.badge, `${row.pid}${row.rid}`, isShow)
      }
    },
    async getLogs({ rid, pid }) {
      const logRes = await app.service('radish').getProgressLog({ rid: rid, pid: pid })
      return logRes.status == 'fail' ? [] : logRes.data
    },
    loadData() {
      this.$emit('reloadProject', this.project)
    },
    getTag(row){
      if (!row.状态 || !row.状态.tag) {
        return 'Call'
      } else if (row.状态.tag === '过保') {
        if (row.状态.detail === '淘汰' || row.状态.detail === '放弃') {
          return '未过保'
        }
        return '过保'
      } else if (row.状态.detail === '淘汰' || row.状态.detail === '放弃') {
        return `已${  row.状态.detail}`
      } else if (row.状态.tag === '已推荐') {
        return '推荐'
      } else if (row.状态.tag === '面试') {
        if (row.状态.detail === '终面') {
          return '终面'
        } else {
          return '面试'
        }
      } else if (row.状态.tag === 'offer谈判') {
        return 'offer谈判'
      } else if (row.状态.tag === 'offer') {
        return '离职辅导'
      } else if (row.状态.tag === '到岗') {
        return '到岗'
      }
      return ''
    },
    getPassTowork(row) {
      const date = row.towork && row.towork.到岗日期
      const promiseMonth = (row.towork && row.towork.试用期 && parseInt(row.towork.试用期)) || 3
      if (!date) return '--'
      let time = new Date(date)
      time = time.setMonth(time.getMonth() + promiseMonth)
      return dateFormat(time, 'yyyy-mm-dd')
    },
    addOffer(row) {
      this.$refs.ProgressDia.open({ radish: row.radish, project: this.project, compName: 'offerMaybe' })
    },
    modifyOffer(row) {
      this.$refs.ProgressDia.open({ radish: row.radish, project: this.project, compName: 'offerEdit' })
    },
    addOfferFeedback(row) {
      this.$refs.ProgressDia.open({ radish: row.radish, project: this.project, compName: 'offerFeedback' })
    },
    showYejifenchengDia(row){
      this.curRow=row
      this.$refs.YejifenchengDia.open({ radish: row.radish, project: this.project})
    },
    yejiConfirm() {
      this.loadData()
      // this.$refs.ProgressDia.open({ radish: this.curRow.radish, project: this.project, compName:'offerConfirm' })
    },
    confirmOffer(row) {
      this.$refs.ProgressDia.open({ radish: row.radish, project: this.project, compName: 'offerConfirm' })
    },
    toLeaveGuide(row) {
      this.$refs.ProgressDia.open({ radish: row.radish, project: this.project, compName: 'leaveGuide' })
    },
    openToworkConfirm(row) {
      this.$refs.ProgressDia.open({ radish: row.radish, project: this.project, compName: 'toworkConfirm' })
    },
    openToworkNot(row) {
      this.$refs.ProgressDia.open({ radish: row.radish, project: this.project, compName: 'toworkNot' })
    },
    openWarrantyConfirm(row) {
      this.$refs.ProgressDia.open({ radish: row.radish, project: this.project, compName: 'warrantyConfirm' })
    },
    openWarrantyNot(row) {
      this.$refs.ProgressDia.open({ radish: row.radish, project: this.project, compName: 'warrantyNot' })
    },
    showRadishProgress(row) {
      this.$refs.radishProgress.open({ pid: this.project._id, rid: row.radish._id, logOnly: true })
      if (this.badge[`${row.pid}${row.rid}`]) this.badge[`${row.pid}${row.rid}`] = false
    },
    removeRow(row) {
      this.list = this.list.filter(val => val._id !== row._id)
    },
    // getRadishStep(radish = {}) {
    //   if (radish.状态.tag === '面试' && radish.状态.detail === '终面') return '面试（终面）'
    //   else if (radish.状态.tag === 'offer谈判') return 'offer谈判'
    //   else if (radish.状态.tag === 'offer') return '离职辅导'
    //   else if (radish.状态.tag === '到岗') return '到岗'
    //   else if (radish.状态.tag === '过保') return '过保'
    //   else return radish.状态.tag
    // },
    handleCurrentChange(val) {
      this.currentRow = val
      this.$emit('currentRow', val)
    },
    getStorage() {
      const storage = localStorage.getItem('radishProgressHistory')
      const obj = (storage && JSON.parse(storage)) || {}

      this.radishProjectStorage = obj

      const logStorage = localStorage.getItem('radishProgressHistory')
      const logsObj = (logStorage && JSON.parse(logStorage)) || {}

      this.radishLogsStorage = logsObj
    },
    // updateStorage(val) {
    //   this.radishProjectStorage[`${val.pid}${val.rid}`] = val.修改历史
    //   localStorage.setItem('radishProgressHistory', JSON.stringify(this.radishProjectStorage))
    // },
    async getList() {
      this.getStorage()
      const { step, radishProjectStorage } = this
      // const filterVal = this.stepMap[this.step]
      const radishProject = this.project.radish_project || []
      console.log('getList -> radishProject', radishProject)
      const toworks = this.project.toworks || []

      let list = []
      if (step === 'offer谈判') {
        list = radishProject.filter(
          v =>
            v.状态 &&
            ((v.状态.tag === '面试' && v.状态.detail === '终面') || v.状态.tag === 'offer谈判') &&
            v.状态.detail !== '淘汰' &&
            v.状态.detail !== '放弃',
        )
      } else if (step === '离职管理') {
        list = radishProject.filter(
          v => v.状态 && v.状态.tag === 'offer' && v.状态.detail !== '淘汰' && v.状态.detail !== '放弃',
        )
      } else if (step === '开票催款') {
        list = radishProject.filter(
          v =>
            v.状态 &&
            (v.状态.tag === '到岗' || v.状态.tag === '过保') &&
            v.状态.detail !== '淘汰' &&
            v.状态.detail !== '放弃',
        )
      }
      // TODO:测试时使用
      // const list = radishProject.filter(v => v.状态 && v.状态.tag === filterVal)
      const res = await app.service('radish').findByIds({ ids: list.map(item => item.rid) })
      if (res.status === 'success') {
        list.forEach(ele => {
          ele.radish = res.data.find(v => v._id === ele.rid)
          ele.towork = toworks.find(v => v.rid === ele.rid)
          if (ele[`修改历史`]) {
            if (
              JSON.stringify(ele[`修改历史`] || {}) !==
              JSON.stringify(radishProjectStorage[`${ele.pid}${ele.rid}`] || {})
            ) {
              this.$set(ele, 'badge', true)
            }
          }
        })
      }
      if (this.step !== step) return
      this.list = list
      await this.checkLogs()
    },
    showRadishDetail(rid) {
      window.open(`${window.frontend}/#/radish-detail-blank/${rid}?p=${this.project._id}`, '_blank')
    },
    dateFormat(time, format) {
      return dateFormat(time, format)
    },
    makePayDoc({ rid, pid }) {
      app.root.$refs.makePayDoc.open({ rid, pid, times: 'first' })
    },
    makePayDoc2({ rid, pid }) {
      app.root.$refs.makePayDoc.open({ rid, pid, times: 'second' })
    },
    async kaipiao(row) {
      const tag = this.getTag(row)
      const res = await app
        .service('radish')
        .modifyStatus({ rid: row.rid, pid: row.pid, status: { tag, detail: '开票中' } })
      if (res.status == 'success') {
        await app.service('company').updateFinanceFapiao({
          rid: row.rid,
          pid: row.pid,
          times: tag == '到岗' ? 'first' : 'second',
        })
        this.$message.success('操作成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    reStart(row) {
      this.$confirm('确定要重启人选吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          // 重启
          await app.service('radish').reStartProgress({ rid: row.rid, pid: row.pid })
          this.loadData()
        })
        .catch(() => {})
    },
  },
}
</script>
<style>
.radish-progress-dot .el-badge__content.is-fixed.is-dot {
  right: 0px;
  top: 6px;
}
</style>
<style scoped>
.bolder {
  font-weight: 700;
}
.ft14 {
  font-size: 14px;
}
</style>
